var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { chain, memoize } from "lodash";
import { computed, toValue } from "vue";
import { useBuiltComponentStore } from "..";
const loadBuiltComponent = memoize((componentId, builtComponentStore) => __awaiter(void 0, void 0, void 0, function* () {
    yield builtComponentStore.fetchBuiltComponent(componentId);
}));
export const useBuiltComponentsFromIds = (componentIds) => {
    const builtComponentStore = useBuiltComponentStore();
    const builtComponents = computed(() => {
        const componentIdsValue = toValue(componentIds);
        return chain(componentIdsValue)
            .map((componentId) => {
            const component = builtComponentStore.getBuiltComponent(componentId);
            if (component) {
                return component;
            }
            else {
                loadBuiltComponent(componentId, builtComponentStore);
                return null;
            }
        })
            .compact()
            .value();
    });
    return { builtComponents };
};
